import { ButtonPosition } from '@/common/manager/position/button-position';
export const config = {
    value: 'filterValidate',
    position: [ButtonPosition.tableToolArea, ButtonPosition.tableBatchArea],
    action: (arg) => {
        const { buttonConfig, _context } = arg || {};
        const { options = {} } = buttonConfig;
        const { _bindFilter } = options;
        if (typeof _bindFilter === 'string' && _context) {
            const filter = _context.$(_bindFilter);
            const formInstance = filter?.getFormInstance?.();
            if (formInstance?.validate) {
                return formInstance.validate();
            }
        }
    },
};
